import { SortClickHandler, SortOrderItem } from "../RtSort";

export interface RtCtrlSort {
  readonly sortOrder: SortOrderItem[];
  sort(order: SortOrderItem[]): void;
  onSortClick(columnKey: string | undefined, handler?: SortClickHandler): void;
}

export const singleSortClickHandler: SortClickHandler = (
  columnKey,
  prevOrder,
) => {
  if (!columnKey) return [];
  const item = prevOrder.find((it) => it.columnKey === columnKey);
  if (!item) {
    return [{ columnKey, mode: "ascend" }];
  }
  if (item.mode === "ascend") {
    return [{ columnKey, mode: "descend" }];
  }
  return [];
};

export const multiSortClickHandler: SortClickHandler = (
  columnKey,
  prevOrder,
) => {
  if (!columnKey) return []; // TODO: временно
  const pos = prevOrder.findIndex((it) => it.columnKey === columnKey);
  if (pos < 0) return [...prevOrder, { columnKey, mode: "ascend" }];
  const newOrder = [...prevOrder];
  const item = newOrder[pos];
  if (item?.mode === "ascend") {
    item.mode = "descend";
  } else {
    newOrder.splice(pos, 1);
  }
  return newOrder;
};
